module.exports = __webpack_public_path__ + "static/media/IconTemplates_-80.8855ce21.svg";